<template>
  <div class="welcome">
    <!-- KV轮播 -->
    <div class="kv-carousel-container" style="overflow: hidden">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in kvData" :key="index">
          <div class="kv-slide">
            <!-- 背景图片 -->
            <div class="kv-bg-container">
              <div class="kv-bg-leftblock"></div>
              <!-- <img class="kv-bg-image" :src="preText + item.imageUrl" > -->
              <img class="kv-bg-image" :src="item.kvImageUrl" />
            </div>

            <!-- 悬浮文字 -->
            <div class="kv-text-overlay kv-title">{{ item.title }}</div>
            <div class="kv-text-overlay kv-subtitle">{{ item.subTitle }}</div>
            <div
              class="kv-text-overlay kv-link"
              @click="clickButton(item.linkUrl,1)"
            >
              了解详情
            </div>
            <!-- 分页器悬浮在图片上 -->
            <div class="kv-pagination-overlay"></div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination-kv"></div>
    </div>

    <div class="recommend-container">
      <div class="recommend-text">为您推荐</div>
      <div class="recommend-text">起亚热卖车型</div>
    </div>

    <!-- 车型轮播 -->
    <div
      ref="slideCarousel"
      class="carousel-container-carmodel"
      style="overflow: hidden"
    >
      <div class="swiper-wrapper" id="specialPosition">
        <div
          class="swiper-slide"
          v-for="item in getPartVideos()"
          :key="item.index"
        >
          <div class="carmodel-container">
            <!-- 图片 -->
            <!-- <img :src="preText + item.coverImgUrl"> -->
            <img :src="item.coverImgUrl" />
            <!-- 按钮 -->
            <div class="swiper-button-container">
              <div
                class="swiper-button"
                style="border-right: 1px solid rgba(208, 213, 219, 1)"
                @click="clickButton(item.modelPageUrl,2)"
              >
                了解详情
              </div>
              <div
                class="swiper-button"
                @click="clickButton(item.testDriveUrl,3)"
              >
                预约试驾
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination-carmodel"></div>
    </div>
  </div>
</template>
<script>
import { isPortraitFun, isPc, isWeiXin, isAndroid } from "@/utils/utils.js";
import Swiper from "swiper";
import { aiUrl } from "@/config/base";

export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText: "https://www.kia.cn",

      kvData: [],
      vehicleList: [],
      currentPage: 1,
      isShowCover: false,
      swiperCover: null,
      token: "",
    };
  },
  computed: {
    isSafari() {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return true;
      } else {
        return false;
      } //判断是否Safari浏览器
    },
  },
  watch: {},
  created() {
    const userInfo = localStorage.getItem("user");
    var token = "";
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      token = this.userInfo.token;
    }
    this.token = token;
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    // 调用接口获取数据
    this.fetchKVList();
    this.fetchVehicleList();
    // this.slideBanner()
    window.addEventListener("resize", this.setResize);
    var that = this;
    this.$nextTick(() => {
      //图片轮播
      if (this.isPortrait) {
        var slidesperviewImg = 1;
        var slidesperviewVideo = 1.2;
        var initialslide = 0;
        var spacebetween1 = 0;
        var spacebetween2 = 0;
      } else {
        var slidesperviewImg = 2.5;
        var slidesperviewVideo = 3.2;
        var initialslide = 0;
        var spacebetween1 = 10;
        var spacebetween2 = 20;
      }
      //KV轮播
      this.swiper1 = new Swiper(".kv-carousel-container", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        resizeObserver: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preloadImages: true,
        updateOnImagesReady: true,
        pagination: {
          el: ".swiper-pagination-kv",
          type: "bullets",
        },
      });

      //车型轮播
      this.swiper2 = new Swiper(".carousel-container-carmodel", {
        slidesPerView: "auto",
        initialSlide: initialslide,
        spaceBetween: spacebetween2,
        centeredSlides: false,
        // loop: true,
        // 关键：监听DOM与父容器变化，确保异步数据后正确布局
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        resizeObserver: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preloadImages: true,
        updateOnImagesReady: true,
        pagination: {
          el: ".swiper-pagination-carmodel",
          type: "progressbar",
        },
      });
      //切换
      this.swiper2.on("slideChange", function () {});
      //图片弹出轮播
      // window.addEventListener("click", this.showCover)
      this.swiperCover = new Swiper(".swiper-container2", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: ".swiper-pagination2",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button-next2",
          prevEl: ".swiper-button-prev2",
        },
      });
    });
  },
  methods: {
    // 获取KV列表
    async fetchKVList() {
      const that = this;
      try {
        const res = await this.$axios.get(
          `${aiUrl}kvVehicle/getKVListWelcome`,
          {
            headers: {
              token: that.token,
            },
          }
        );
        const response = res.data || res;
        if (response.code == 200) {
          this.kvData = response.data || [];
          this.$nextTick(() => {
            // 动态数据到位后，销毁并重建，确保 loop 生效
            this.initKvSwiper();
          });
        }
      } catch (error) {
        console.warn("获取KV列表失败:", error);
      }
    },

    // 获取车型信息列表
    async fetchVehicleList() {
      const that = this;
      try {
        const res = await this.$axios.get(
          `${aiUrl}kvVehicle/getVehicleListWelcome`,
          {
            headers: {
              token: that.token,
            },
          }
        );
        const response = res.data || res;
        if (response.code == 200) {
          this.vehicleList = response.data || [];
          // 数据到位后，等待DOM更新再刷新swiper布局
          this.$nextTick(() => {
            if (this.swiper2 && this.swiper2.update) {
              this.swiper2.update();
            }
          });
        }
      } catch (error) {
        console.warn("获取车型信息列表失败:", error);
      }
    },
    // 初始化 KV 轮播，确保循环与分页可点击
    initKvSwiper() {
      try {
        if (this.swiper1 && this.swiper1.destroy) {
          this.swiper1.destroy(true, true);
          this.swiper1 = null;
        }
        const enableLoop = this.kvData && this.kvData.length > 1;
        this.swiper1 = new Swiper(".kv-carousel-container", {
          slidesPerView: 1,
          loop: enableLoop,
          speed: 600,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          },
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preloadImages: true,
          updateOnImagesReady: true,
          pagination: {
            el: ".swiper-pagination-kv",
            type: "bullets",
            clickable: true,
          },
        });
      } catch (e) {
        console.warn("初始化KV轮播失败:", e);
      }
    },

    getPartVideos() {
      var list = this.vehicleList;
      return list;
    },
    getRefName(index) {
      return `videoPlayerSwiper${index}`;
    },
    setResize() {
      this.isPortrait = isPortraitFun();
    },
    showCover(e) {
      const index = e.target.getAttribute("data-index");
      console.log(index);
      console.log(1111);
      if (index) {
        this.isShowCover = true;
        this.$nextTick(() => {
          this.swiperCover = new Swiper(".swiper-container2", {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: ".swiper-pagination2",
              type: "fraction",
            },
            navigation: {
              nextEl: ".swiper-button-next2",
              prevEl: ".swiper-button-prev2",
            },
          });
        });
        // window.removeEventListener("click", this.showCover)
        //开始全屏预览
        window.parent.postMessage({ type: "ev5ImgSwiperOpen" }, "*");
      }
    },
    hideCover() {
      this.isShowCover = false;
      this.swiperCover = null;
      window.addEventListener("click", this.showCover);
      //关闭全屏预览
      window.parent.postMessage({ type: "ev5ImgSwiperClose" }, "*");
    },
    clickButton(targetUrl,type) {
      var typeText = '';
      if(type == 1){
       typeText = '头部轮播了解详情'
      } else if(type == 2){
         typeText = '车型卡片了解详情'
      } else if(type == 3){
         typeText = '车型卡片预约试驾'
      }
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '首页-'+typeText+'-跳转链接'+targetUrl, 1]);
      stm_clicki("send",'event',window.location.href, "点击", '首页-'+typeText+'-跳转链接'+targetUrl); 
      
      if (!targetUrl) return;
      const a = document.createElement("a");
      a.href = String(targetUrl).trim();
      a.target = "_blank";
      a.rel = "noopener";
      a.click();
    },
  },
};
</script>
<style lang="scss" scoped>
.carmodel-container {
  @media (min-width: 767px) {
    img {
      //按宽比例
      //width: calc(390 / 1920 * 100vw);
      //固定宽
      width: calc(390 / 1080 * 100vh);
      height: calc(326 / 1080 * 100vh);

      // height: calc((326 + 0) / 1920 * 100vw);
      // background-color: #fff;
      // background-color: #000;
      border-radius: calc(6 / 1920 * 100vw);
      // width: 100%;
      // height: 100%;
    }
    .swiper-button-container {
      //按宽比例
      //width: calc(390 / 1920 * 100vw);
      //固定宽
      width: calc(390 / 1080 * 100vh);

      height: calc(56 / 1080 * 100vh);
      display: flex;
      justify-content: space-between;
      background-color: #fff;
      border-radius: calc(6 / 1920 * 100vw);
      margin-top: calc(8 / 1920 * 100vw);
      overflow: hidden;
    }
    .swiper-button {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      font-size: calc(16 / 1080 * 100vh);
      cursor: pointer;
    }
    .swiper-button:hover {
      background-color: rgba(6, 20, 31, 1);
      color: #fff;
    }
  }
  .icons {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    z-index: 99;

    a {
      .icon {
        display: block;
        width: 50px;
        height: 50px;
        //background: url('../../assets/images/play-circle-line.png') no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
  }
}

.title-text {
  color: #ffffff;
  width: 100%;
  text-align: center;

  @media (min-width: 767px) {
    font-size: calc(45 / 1920 * 100vw);
    padding: calc(100 / 1920 * 100vw) 0;
  }

  @media (max-width: 767px) {
    font-size: calc(22 / 375 * 100vw);
    padding-top: calc(60 / 375 * 100vw);
    padding-bottom: calc(20 / 375 * 100vw);
  }
}

//pc start
@media (min-width: 767px) {
  .kv-carousel-container {
    //按宽比例
    //width: calc(1255 / 1920 * 100vw);
    //height: calc(369 / 1920 * 100vw);
    //固定宽
    width: calc(100% - 39 / 1920 * 100vw);
    height: calc(320 / 1080 * 100vh);
    min-height: 180px;
    overflow: hidden;
    position: relative;
    margin-bottom: calc(32 / 1080 * 100vh);

    .kv-slide {
      position: relative;
      width: 100%;
      height: 100%;
      // background-color: #000;

      .kv-bg-container {
        width: 100%;
        height: calc(320 / 1080 * 100vh);
        min-height: 180px;
        display: flex;
        border-radius: calc(6 / 1920 * 100vw);
        overflow: hidden;
      }
      .kv-bg-leftblock {
        width: calc(369 / 1080 * 100vh);
        min-width: 200px;
        height: 100%;
        background-color: #000;
        margin-left: 1px; //防止有黑边
        border-radius: calc(6 / 1920 * 100vw) 0 0 calc(6 / 1920 * 100vw);
      }
      .kv-bg-image {
        //按宽比例
        // width: 100%;
        //固定宽
        flex: 1 1 auto;
        width: 0;
        height: 100%;
        object-fit: cover;
        background-color: grey;
      }

      .kv-text-overlay {
        position: absolute;
        left: calc(40 / 1080 * 100vh);
        color: #ffffff;
        font-family: "FZLanTingHeiS-DB-GB";
      }
      .kv-title {
        top: calc(50 / 1080 * 100vh);
        line-height: calc(30 / 1080 * 100vh);
        font-size: calc(30 / 1080 * 100vh);
      }

      .kv-subtitle {
        top: calc(90 / 1080 * 100vh);
        font-size: calc(16.8 / 1080 * 100vh);
      }

      .kv-link {
        // top: calc(294 / 1920 * 100vw);
        bottom: 29px;
        font-size: calc(12 / 1080 * 100vh);
        border-bottom: calc(1 / 1080 * 100vh) solid transparent;
        cursor: pointer;
        display: inline-block;

        &::after {
          content: "";
          position: absolute;
          bottom: calc(-1 / 1080 * 100vh);
          left: 0;
          width: 0;
          height: calc(1 / 1080 * 100vh);
          background-color: #fff;
          transition: width 0.3s ease;
          transform-origin: left center;
        }

        &:hover {
          &::after {
            width: 100%;
            transform-origin: left center;
          }
        }

        &:not(:hover) {
          &::after {
            transform-origin: right center;
            width: 0;
          }
        }
      }

      .kv-pagination-overlay {
        position: absolute;
        bottom: calc(30 / 1920 * 100vw);
        left: 50%;
        transform: translateX(-50%);
        z-index: 15;
      }
    }

    ::v-deep .swiper-pagination-bullets {
      position: absolute;
      bottom: calc(30 / 1920 * 100vw);
      right: 30px;
      left: auto;
      width: auto;
      // transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 20;
    }

    ::v-deep .swiper-pagination-bullet {
      margin: 0 2px !important;
      width: calc(30 / 1920 * 100vw);
      height: calc(3 / 1920 * 100vw);
      border-radius: calc(3 / 1920 * 100vw);
      background-color: rgba(255, 255, 255, 0.5);
      opacity: 1;
      transition: all 0.3s ease;
    }

    ::v-deep .swiper-pagination-bullet-active {
      background-color: #ffffff;
      // transform: scale(1.2);
    }
  }

  .recommend-container {
    margin-bottom: calc(15 / 1080 * 100vh);
    .recommend-text {
      font-size: calc(20 / 1080 * 100vh);
      font-family: "FZLanTingHeiS-DB-GB";
    }
  }

  .welcome {
    position: relative;
    height: 100%;
    width: 100%;
    user-select: none;
    // overflow-y: auto;
    // padding: calc(39 / 1920 * 100vw) calc(56 / 1920 * 100vw);
    // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-pc.png');
    // background-repeat: no-repeat; /* 防止重复 */
    // background-size: cover;
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .video-swiper-icon {
    position: absolute;
    top: calc(152 / 1920 * 100vw);
    left: calc(330 / 1920 * 100vw);
    width: calc(316 / 1920 * 100vw);
    height: calc(135 / 1920 * 100vw);
  }

  .carousel-hover-stripe {
    position: absolute;
    left: calc(110 / 1920 * 100vw);
    top: calc(50% - 339 / 1920 * 100vw);
    width: calc(1206 / 1920 * 100vw);
    height: calc(105 / 1920 * 100vw);
    // font-size: calc(34 / 1920 * 100vw);
    font-family: "zhonghei";
    background-image: url("https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-pc.png");
    background-repeat: no-repeat;
    /* 防止重复 */
    // background-position: center; /* 图片居中 */
    background-size: 100% 100%;
    z-index: 99;
  }

  .carousel-container-carmodel {
    // width: 100%;
    width: calc(100% - 39 / 1920 * 100vw);
    // height: calc(543 / 1920 * 100vw);
    // position: absolute;
    // left: 0;
    // top: calc(345 / 1920 * 100vw);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ::v-deep .swiper-pagination-bullets {
      display: flex;
      align-items: center;
      justify-content: end;
      padding-right: calc(358 / 1920 * 100vw);
    }
    ::v-deep .swiper-pagination-bullet {
      margin: 0 calc(4 / 1920 * 100vw);
      width: calc(14 / 1920 * 100vw);
      height: calc(14 / 1920 * 100vw);
      border-radius: calc(14 / 1920 * 100vw);
      background-color: #d9d9d9;
    }

    ::v-deep .swiper-pagination-bullet-active {
      background-color: #ffffff;
      display: inline-block;
    }

    ::v-deep .swiper-slide {
      // opacity: 0.5;
      //按宽比例
      //width: calc(390 / 1920 * 100vw);
      //固定宽
      width: calc(390 / 1080 * 100vh);

      .icons {
        display: none;
      }

      .video-text {
        display: none;
      }
    }

    ::v-deep .swiper-slide-active {
      opacity: 1;

      .icons {
        display: block;
      }

      .video-text {
        position: absolute;
        top: calc(543 / 1920 * 100vw);
        display: block;
        color: #ffffff;
        font-size: calc(25 / 1920 * 100vw);
        padding: calc(30 / 1920 * 100vw) 0;
      }
    }
    ::v-deep .swiper-pagination-progressbar {
      position: relative;
      width: 50%;
      height: calc(3 / 1920 * 100vw);
      border-radius: 0;
      background-color: rgba(0, 0, 0, 0.2);
    }

    ::v-deep .swiper-pagination-progressbar-fill {
      background-color: rgba(0, 0, 0, 0.4);
      display: inline-block;
    }
  }
}
//pc end
//mob strat
@media (max-width: 767px) {
  .kv-carousel-container {
    width: 100%;
    height: calc(300 / 375 * 100vw);
    position: relative;
    margin-bottom: calc(30 / 375 * 100vw);

    .kv-slide {
      position: relative;
      width: 100%;
      height: 100%;

      .kv-bg-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .kv-text-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: #ffffff;
        font-family: "FZLanTingHeiS-DB-GB";
        z-index: 10;

        .kv-title {
          font-size: calc(28 / 375 * 100vw);

          margin-bottom: calc(12 / 375 * 100vw);
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }

        .kv-subtitle {
          font-size: calc(20 / 375 * 100vw);
          margin-bottom: calc(10 / 375 * 100vw);
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }

        .kv-link {
          font-size: calc(16 / 375 * 100vw);
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }
      }

      .kv-pagination-overlay {
        position: absolute;
        bottom: calc(20 / 375 * 100vw);
        left: 50%;
        transform: translateX(-50%);
        z-index: 15;
      }
    }

    ::v-deep .swiper-pagination-bullets {
      position: absolute;
      bottom: calc(20 / 375 * 100vw);
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 20;
    }

    ::v-deep .swiper-pagination-bullet {
      margin: 0 calc(6 / 375 * 100vw);
      width: calc(10 / 375 * 100vw);
      height: calc(10 / 375 * 100vw);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.5);
      transition: all 0.3s ease;
    }

    ::v-deep .swiper-pagination-bullet-active {
      background-color: #ffffff;
      transform: scale(1.2);
    }
  }

  ::v-deep .swiper-slide {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.5;
  }
  ::v-deep .swiper-slide-active {
    opacity: 1;
  }

  ::v-deep .swiper-pagination-bullet {
    margin: 0 calc(4 / 375 * 100vw);
    width: calc(8 / 375 * 100vw);
    height: calc(8 / 375 * 100vw);
    border-radius: calc(8 / 375 * 100vw);
    background-color: #d9d9d9;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background-color: #ffffff;
    display: inline-block;
  }
  .welcome {
    position: relative;
    height: calc(555 / 375 * 100vw);
    width: 100%;
    user-select: none;
    background-color: rgba(30, 128, 193, 1);
    // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/third-page-background-mob.png');
    // background-repeat: no-repeat; /* 防止重复 */
    // background-size: cover;
    // padding-top: calc(50 / 375 * 100vw );
    // padding-bottom: calc(80 / 375 * 100vw );
  }
  .bg {
    position: absolute;
    width: 100%;
  }
  .carousel-hover-stripe {
    position: absolute;
    left: calc(26.5 / 375 * 100vw);
    bottom: calc((50 - 40 + 357) / 375 * 100vw);
    width: calc(322.1 / 375 * 100vw);
    height: calc(40 / 375 * 100vw);
    border-radius: 15px 15px 0 0;
    // font-size: calc(34 / 1920 * 100vw);
    font-family: "zhonghei";
    background-image: url("https://www.kia.cn/assets/~/media/images/activity/aowang2025/purple-stripe-mob.png");
    background-repeat: no-repeat;
    /* 防止重复 */
    // background-position: center; /* 图片居中 */
    background-size: 100% 100%;
    z-index: 99;
  }

  .carousel-container-carmodel {
    width: calc(375 / 375 * 100vw);
    // margin-left: calc(26.5 / 375 * 100vw);
    // height: calc(220 / 375 * 100vw);
    position: absolute;
    left: 0;
    top: calc(200 / 375 * 100vw);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .video-text {
      position: absolute;
      top: calc(216 / 375 * 100vw);
      display: block;
      color: #ffffff;
      font-size: calc(16 / 375 * 100vw);
      padding-top: calc(13 / 375 * 100vw);
    }
  }
}

@media screen and (orientation: portrait) {
  //隐藏掉鼠标悬浮出现的左右切换按钮
  ::v-deep .el-carousel__arrow {
    display: none;
  }
}

::v-deep .el-carousel__indicators {
  // display: none;
  bottom: 0;
}

::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

::v-deep .is-active .el-carousel__button {
  // background-color: #ffffff;
  background: rgba(0, 80, 255, 1);
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

//隐藏掉鼠标悬浮出现的左右切换按钮
// ::v-deep .el-carousel__arrow{
//   display: none;
// }
::v-deep .el-carousel__arrow {
  background-color: #ffffff;

  i {
    font-size: 30px;
  }
}

.el-carousel__arrow:hover {
  background-color: #475669;
}

::v-deep .el-carousel__container {
  position: relative;
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.swiper {
  width: 100%;
  height: 400px;
}

// .swiper-slide {
//   text-align: center;
//   font-size: 18px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }

// .swiper-slide img {
//   display: block;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }
.swiper-pagination-carmodel {
  width: 100%;
  text-align: center;
  z-index: 10;
  position: static;
  margin: calc(34 / 1080 * 100vh) 0;
}

.swiper-pagination-img {
  // position: absolute;
  // bottom: 70px;
  // left: 0;
  width: 100%;
  text-align: center;
  z-index: 10;

  @media (min-width: 767px) {
    // padding: calc(100 / 1920 * 100vw) 0 calc(50 / 1920 * 100vw) 0;
    margin: calc(100 / 1920 * 100vw) 0;
  }

  @media (max-width: 767px) {
  }
}

.cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #000000;
  z-index: 210;

  .el-icon-close {
    color: #fff;
    font-size: 40px;
    cursor: pointer;
    position: absolute;
    z-index: 99;
    right: 50px;
    top: 50px;

    &-mob {
      font-size: 30px;
      right: 20px;
    }
  }

  .pop {
    position: relative;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .swiper-container2 {
    width: 70vw;
    height: auto;
    overflow: hidden;

    /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
    /* height: 80%; */
    .swiper-slide {
      background: rgba($color: #000000, $alpha: 0);

      // img {
      //   width: 78%;
      //   height: auto;
      // }

      @media (max-width: 768px) {
        img {
          width: 100%;
        }
      }
    }

    &-mob {
      width: 100vw;
    }
  }

  .swiper-pagination-fraction {
    position: absolute;
    z-index: 999;
    bottom: -30px;
    color: #fff;
  }

  .swiper-button-next,
  .swiper-button-prev {
    background: rgba($color: #000, $alpha: 0);
    transition: all 0.5s;
    color: #fff;
    font-size: 30px;

    transform: translateY(-50%);

    &::after {
      /* content: none; */
      font-size: 30px;
      font-weight: 400;
      color: #fff;
    }

    &:hover {
      background: rgba($color: #05141f, $alpha: 0);
    }

    &:hover::after {
      color: #fff;
    }
  }

  .swiper-button-prev,
  .swiper-button-next:focus {
    outline: none;
  }

  .swiper-button-next2 {
    right: 20px;
    transform: translateY(-25%);
  }

  .swiper-button-prev2 {
    left: 20px;
    transform: translateY(-25%);
  }

  @media (max-width: 768px) {
    .swiper-button-next2 {
      width: auto;
      height: auto;
      right: 2%;
      transform: translateY(25%);
    }

    .swiper-button-prev2 {
      width: auto;
      height: auto;
      left: 2%;
      transform: translateY(25%);
    }
  }
}
</style>
